import { FC, useState } from 'react'

import { Dropdown, Icon, Title, Text, Button, Loading } from '../../components/UI'
import { notifyService } from '../../services'
import config from '../../../config'

type HeaderProps = {
  notify: any,
  notifyShow: boolean,
  onNotifyChange(): void,
  onNotifyRead(id: number): void
}

const HeaderNotify:FC<HeaderProps> = ({ notify = {}, notifyShow, onNotifyChange, onNotifyRead })  => {
  const [notifyResp, setNotifyResp] = useState<any[]>([])

  const getIconName = (type: string) => {
    if(type === 'family_group') return 'family-group'
    else if(type === 'exams_procedures') return 'test-results'

    return ''
  }

  const getNotifyResp = (id: number) => {
    const lNotifyResp = notifyResp.find(it => it.id === id)
    return (lNotifyResp ? lNotifyResp : {
      id: 0,
      status: '',
      message: ''
    })
  }

  const updateNotifyResp = (id: number, message: string = '', status: 'SUCCESS' | 'ERROR' | '' = '') => {
    const index = notifyResp.findIndex(it => it.id === id)

    if(index > -1) {
      let lNotifyResp: any[] = notifyResp
      lNotifyResp[index] = {
        status,
        id,
        message
      }
      setNotifyResp(lNotifyResp)

    } else {
      setNotifyResp([
        ...notifyResp,
        {
          status,
          id,
          message
        }
      ])
    }
  }

  const postNotification = async (serv: string, id: number) => {
    const resp = await notifyService.postNotification(serv)

    updateNotifyResp(
      id,
      `<p class="text fz-13 lh-4">${(resp && resp.status === 'Ok' ? resp.data.msg : resp.message)}</p>`,
      (resp && resp.status === 'Ok' ? 'SUCCESS' : 'ERROR')
    )

    if(resp && resp.status === 'Ok') onNotifyRead(id)
  }

  const onNotifyClick = (serv: string, id: number) => {
    updateNotifyResp(id)
    postNotification(serv, id)
  }

  const btnDisabled = (id: number) => {
    const lNotifyResp = getNotifyResp(id)
    return (lNotifyResp && lNotifyResp.id === id && lNotifyResp.status === '')
  }

  const notifyCount = notify.getNotificationsNewCount()

  return (
    <>
      <div className="header_btn-notify" onClick={onNotifyChange}>
        {notifyCount > 0 && <span className="badge header_btn-notify_badge">{notifyCount}</span>}
        <Icon name="notify" />
      </div>

      <Dropdown show={notifyShow} className="header_dropdown_notify">
        <div className="dropdown-notify">
          <Title component="h4" size="14" color="primary" weight="bold" className="pl-15 mb-20">Notificaciones</Title>

          <div className="notify_content">
            {notify.notifications ?
                notify.notifications.length ?
                  notify.notifications.map((it: any, i: number) => {
                    const { name: notifyTypeName } = it.notification_type
                    const lNotifyResp: any = getNotifyResp(it.id)

                    return (
                      <div key={i} className={`notify_box ${it.active ? 'notify_box--active' : ''} ${i > 0 ? 'mt-10' : ''}`}>
                        <div className="d-flex">
                          <div className="notify_col-1">
                            <div className="notify_icon">
                              <Icon name={getIconName(notifyTypeName)} />
                            </div>
                          </div>

                          {notifyTypeName === 'family_group' && it.id === lNotifyResp.id && lNotifyResp.status !== '' ?
                              <div dangerouslySetInnerHTML={{  __html: lNotifyResp.message }} />
                            :
                              <Text size="13" weight={it.type === 'family_group' ? 'semibold' : ''}>{it.text}</Text>
                          }
                        </div>

                        {notifyTypeName === 'family_group' ?
                            it.id === lNotifyResp.id && lNotifyResp.status === 'SUCCESS' ?
                                ''
                              :
                                <div className="row mt-20">
                                  <div className="col-12">
                                    <Button 
                                      size="md" 
                                      color="primary" 
                                      fullWidth
                                      component='a'
                                      to={`${config.ROUTES.DASHBOARD.FAMILYGROUP.HOME}?tab=requests&request_id=${it?.request_family_group_id ? it.request_family_group_id : '0'}`}
                                    >
                                      VER SOLICITUD
                                    </Button>
                                  </div>
                                </div>
                          :
                            ''
                        }
                      </div>
                    )
                  })
                :
                  <div className="notify_box">
                    <Text size="13">No tienes notificaciones</Text>
                  </div>
              :
                <Loading size="md" align="center" />
            }
          </div>
        </div>
      </Dropdown>
    </>
  )
}

export { HeaderNotify }